module.exports = __webpack_public_path__ + "img/FI.d852ae32.svg";